
import { defineComponent } from 'vue';

import { useInsertDataStore } from '@/hooks/use_insert_data_store';
import { OptionItem } from '@/models/option_item';
import { Style } from '@/models/style';

import BaseStyle from './BaseStyle.vue';
import SurveyInputSelect from './SurveyInputSelect.vue';

export default defineComponent({
  name: 'BaseDialog',
  components: {

    SurveyInputSelect,
    BaseStyle,
  },
  setup() {
    const { purchaseCount } = useInsertDataStore();
    const options: OptionItem[] = [];

    for (let i = 4; i <= 200; i++) {

      // 新しいOptionItemを作成して配列に追加
      options.push(new OptionItem(i.toString(), i.toString()));
    }
    return {
      purchaseCount,
      options,
      Style,
    };
  },
});
